import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type PerformanceRequirement } from 'api/performanceAPI';

export interface PerformanceSliceState {
    performanceEntries?: Record<string, PerformanceRequirement[]>;
}

const initialState: PerformanceSliceState = { performanceEntries: {} };

export const performanceSlice = createSlice({
    name: 'performance',
    initialState,
    reducers: {
        setPerformanceItemsForReferral(
            state,
            action: PayloadAction<{
                referralId: string;
                performanceItems: PerformanceRequirement[];
            }>,
        ) {
            return {
                ...state,
                performanceEntries: {
                    ...state.performanceEntries,
                    [action.payload.referralId]: action.payload.performanceItems,
                },
            };
        },
    },
});

export const { setPerformanceItemsForReferral } = performanceSlice.actions;
